import { Box, Link } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ErrorCommon } from "src/components/pages/error/common";
import { Typography } from "src/components-mui/base/typography/typography";

const serviceEmail = "service@wikifolio.com";

interface IError500Props {
    errorCode?: string;
    showLogo?: boolean;
    staticTranslations?: (key: string) => string;
}

export const Error500 = ({ errorCode, showLogo, staticTranslations }: IError500Props) => {
    const { t } = useTranslation("common");

    const activeT = staticTranslations ?? t;

    return (
        <ErrorCommon subHeadline={activeT("errors.pages.500")} showLogo={showLogo} staticTranslations={staticTranslations}>
            {errorCode && (
                <Typography
                    component="p"
                    sx={{
                        mt: [2, 2, 3, 5],
                        textAlign: ["center", "center", "unset"],
                    }}
                >
                    <strong>{activeT("errors.labels.code")}: </strong>
                    <Box
                        sx={{
                            display: "inline-block",
                        }}
                    >
                        {errorCode}
                    </Box>
                </Typography>
            )}

            <Typography
                component="p"
                sx={{
                    mt: 2,
                    fontSize: ["lg", "xl"],
                    textAlign: ["center", "center", "unset"],
                }}
            >
                {activeT("errors.messages.500.heading")}
                <br />
                {activeT("errors.messages.500.message")}
            </Typography>

            <Typography
                component="p"
                sx={{
                    mt: 2,
                    fontSize: ["lg", "xl"],
                    textAlign: ["center", "center", "unset"],
                }}
            >
                {activeT("errors.messages.500.support-contact")}{" "}
                <Link
                    href={`mailto:${serviceEmail}`}
                    sx={{
                        fontSize: "inherit",
                    }}
                >
                    {serviceEmail}
                </Link>
                .
            </Typography>
        </ErrorCommon>
    );
};
